module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#mynews",
      toString: function () {
        return this.url;
      }
    }